<div class="modal-overlay" (mousedown)="onClose()">
  <div class="modal-container" (mousedown)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      @if (inWritingPromptMode) {
      <ex-button
        class="reset-button"
        variant="ghost"
        (click)="clearPrompt()"
        icon="arrow-left-fill"
      ></ex-button>
      }
      <p class="modal-title">
        @if (filledPrompt.title) {
        {{ filledPrompt.title }}
        } @else if (inWritingPromptMode) {
        {{ "search.smart-search-modal.write-your-prompt" | translate }}
        } @else {
        {{ "search.smart-search-modal.title" | translate }}
        }
      </p>
      <ex-button
        class="close-button"
        variant="ghost"
        (click)="onClose()"
        icon="x"
      ></ex-button>
    </div>

    @if (!inWritingPromptMode) {
    <!-- Search Context Section -->
    <div class="search-context">
      <span class="section-title">{{
        "search.smart-search-modal.your-search" | translate
      }}</span>

        @if (searchConfig.topic) {
          <div class="filter-item">
        <span>{{ "search.smart-search-modal.topic" | translate }} : &nbsp;</span>
            <span class="filter-value">{{ searchConfig.topic }}</span>
          </div>
        }
        @if (searchConfig.keywords) {
          <div class="filter-item">
            <span>{{ "search.smart-search-modal.keywords" | translate }} : &nbsp;</span>
            <span class="filter-value">{{ searchConfig.keywords }}</span>
          </div>
        }

        <div class="filter-item">
        <span>{{ "search.smart-search-modal.perimeter" | translate }} : &nbsp;</span>
            <span class="filter-value">{{ modalPerimeter }}</span>
          </div>
      </div>

    <!-- Pre-configured Prompts Section -->
    @if (prompts.length > 0) {
    <div class="prompts-section">
      <h3 class="section-title">
        {{ "search.smart-search-modal.select-prompt" | translate }}
      </h3>
      <div class="prompts-list">
        @for (prompt of prompts; track prompt.title) {
          <ex-button
            class="prompt-button"
            variant="ghost"
            (click)="selectPrompt(prompt)"
          >
            {{ prompt.title }}
          </ex-button>
        }
      </div>
    </div>
    }

    }

    <div class="textarea-wrapper">
      <textarea
        class="custom-prompt-section"
        [placeholder]="
          'search.smart-search-modal.custom-prompt-placeholder' | translate
        "
        [(ngModel)]="displayedPromptText"
        (focus)="onTextareaFocus()"
        (ngModelChange)="onPromptTextChange()"
      >
      </textarea>
      @if (inWritingPromptMode) {
        <div class="textarea-footer">
          <ex-button
            class="copy-prompt-button"
            variant="ghost"
            icon="copy-fill"
            (click)="copyPrompt(); $event.stopPropagation()"
            #copyTooltip="ngbTooltip"
            [ngbTooltip]="tooltipCopy"
            placement="top"
            triggers=""
          >
            {{ "search.smart-search-modal.copy" | translate }}
          </ex-button>
        </div>

      }
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="filter-buttons">
        <div class="icon-wrapper">
          <ex-button
            (click)="changeSourceStatus(SmartSearchSource.PRESS)"
            icon="newspaper-fill"
            variant="ghost"
            class="filter-btn"
            [ngClass]="{'greyed-out': !selectedSources[SmartSearchSource.PRESS]}"
          >
            {{ "search.smart-search-modal.press" | translate }}
          </ex-button>
          @if (selectedSources[SmartSearchSource.PRESS]) {
            <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
          }
        </div>

        @if (!searchConfig.impacterId) {
        <div class="icon-wrapper">
          <ex-button
            (click)="changeSourceStatus(SmartSearchSource.ADMIN_DOC)"
            iconSrc="assets/images/admin-doc-filled.svg"
            variant="ghost"
            class="filter-btn"
            [ngClass]="{
              'greyed-out': !selectedSources[SmartSearchSource.ADMIN_DOC]
            }"
          >
            {{ "search.smart-search-modal.admin-publications" | translate }}
          </ex-button>
          @if (selectedSources[SmartSearchSource.ADMIN_DOC]) {
          <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
          }
        </div>
        }

        <div class="icon-wrapper">
          <ex-button
            (click)="changeSourceStatus(SmartSearchSource.WEB)"
            icon="globe"
            variant="ghost"
            class="filter-btn"
            [ngClass]="{
              'greyed-out': !selectedSources[SmartSearchSource.WEB]
            }"
          >
            {{ "search.smart-search-modal.web" | translate }}
          </ex-button>
          @if (selectedSources[SmartSearchSource.WEB]) {
          <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
          }
        </div>
      </div>
      <ex-button
        size="x-large"
        (click)="TriggerSmartSearch()"
        icon="shooting-star"
        [disabled]="!canTriggerSmartSearch()"
        #launchButtonTooltip="ngbTooltip"
        [ngbTooltip]="getTooltipMessage() | translate"
        placement="bottom"
        triggers="hover focus"
        [openDelay]="0"
        [closeDelay]="0"
        [disableTooltip]="!shouldShowTooltip()"
        container="body"
      >
        {{ "search.smart-search-modal.launch-analysis" | translate }}
      </ex-button>
    </div>
  </div>
</div>

<ng-template #tooltipCopy>
  <span>{{ "search.smart-search-modal.copied" | translate }} </span>
</ng-template>
